import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { QrCode, Smartphone, KeyRound, LogIn } from "lucide-react";
import { toast } from "sonner";

export default function LoginModal({ open, onClose }) {
  const [mac, setMac] = useState("");
  const [pwd, setPwd] = useState("");
  const [tab, setTab] = useState("mac");

  const submit = (e) => {
    e.preventDefault();
    if (!mac || !pwd) {
      toast.error("Informe o MAC e a Senha");
      return;
    }
    toast.success("Acessando sistema...", { description: `MAC: ${mac}` });
    setTimeout(() => onClose(), 1200);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-[#101014] border-white/10 text-white">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_hardcore-lichterman-3/artifacts/zntek32k_images.png"
              alt="UniPlay UHD"
              className="w-12 h-12 rounded-xl object-cover"
            />
            <div>
              <DialogTitle className="text-2xl font-extrabold text-white">
                UNIPLAY <span className="text-xs font-bold text-cyan-400 align-top">UHD</span>
              </DialogTitle>
              <p className="text-xs text-white/60">Painel do Cliente</p>
            </div>
          </div>
        </DialogHeader>

        <div className="flex gap-1 p-1 rounded-xl bg-white/5 mt-2">
          <button onClick={() => setTab("mac")} className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-semibold transition ${tab === "mac" ? "bg-red-600 text-white" : "text-white/60 hover:text-white"}`}>
            <KeyRound className="w-4 h-4" /> MAC + Senha
          </button>
          <button onClick={() => setTab("qr")} className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-semibold transition ${tab === "qr" ? "bg-red-600 text-white" : "text-white/60 hover:text-white"}`}>
            <QrCode className="w-4 h-4" /> QR Code
          </button>
        </div>

        {tab === "mac" ? (
          <form onSubmit={submit} className="space-y-4 mt-2">
            <p className="text-sm text-white/65">
              Acesse sua conta utilizando o <strong className="text-red-500">mac</strong> de seu aplicativo e sua senha fornecida pelo seu Master.
            </p>
            <div>
              <Label className="text-xs text-white/70">Mac (ex: 00:00:00:00:00:)</Label>
              <div className="relative mt-1">
                <Smartphone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
                <Input value={mac} onChange={(e) => setMac(e.target.value)} placeholder="00:1A:2B:3C:4D:5E" className="pl-9 bg-white/5 border-white/10 focus:border-red-600" />
              </div>
            </div>
            <div>
              <Label className="text-xs text-white/70">Senha!</Label>
              <div className="relative mt-1">
                <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
                <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="••••••••" className="pl-9 bg-white/5 border-white/10 focus:border-red-600" />
              </div>
            </div>
            <button type="submit" className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-xl bg-gradient-to-r from-red-600 to-red-700 text-white font-bold shadow-lg shadow-red-600/30 hover:brightness-110 transition">
              <LogIn className="w-4 h-4" /> ACESSAR SISTEMA
            </button>
          </form>
        ) : (
          <div className="text-center py-3">
            <p className="text-sm text-white/70 mb-4">
              Aplicativo Uniplay tv: acesse sua conta escaneando o QR Code abaixo.
            </p>
            <div className="inline-block p-4 bg-white rounded-2xl">
              <svg xmlns="http://www.w3.org/2000/svg" width="180" height="180" viewBox="0 0 29 29" shapeRendering="crispEdges">
                <rect width="29" height="29" fill="#fff" />
                {Array.from({ length: 29 }).map((_, y) =>
                  Array.from({ length: 29 }).map((_, x) => {
                    const v = (x * 7 + y * 13 + (x ^ y)) % 5;
                    if (v < 2) return <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill="#000" />;
                    return null;
                  })
                )}
                <rect x="0" y="0" width="7" height="7" fill="#fff" />
                <rect x="0" y="0" width="7" height="7" fill="none" stroke="#000" />
                <rect x="2" y="2" width="3" height="3" fill="#000" />
                <rect x="22" y="0" width="7" height="7" fill="#fff" />
                <rect x="22" y="0" width="7" height="7" fill="none" stroke="#000" />
                <rect x="24" y="2" width="3" height="3" fill="#000" />
                <rect x="0" y="22" width="7" height="7" fill="#fff" />
                <rect x="0" y="22" width="7" height="7" fill="none" stroke="#000" />
                <rect x="2" y="24" width="3" height="3" fill="#000" />
              </svg>
            </div>
            <p className="text-xs text-white/50 mt-3">Código expira em 60 segundos</p>
          </div>
        )}

        <div className="mt-2 text-center">
          <p className="text-[11px] text-white/40">UniPlay HD © 2026 • Todos os direitos reservados</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
